import React from 'react'
import SkeletonDivElement from './skeletonDivElement'

const SkeletonForServices = (key = '1') => {
    return (
        <div key={key} className="row mx-0 shadow bg-white my-2" style={{ height: "", borderRadius: '16px' }}>
            <div className="col-12 d-flex p-2">

                <div>
                    <SkeletonDivElement height={'80px'} width={'110px'} borderRadius={'14px'} />
                </div>

                <div className="w-100 h-100 d-flex flex-column justify-content-between ms-3">
                    <div>
                        <div className="mb-2">
                            <SkeletonDivElement height={'20px'} width={'30%'} borderRadius={'14px'} />
                        </div>

                        <div className="mb-2">
                            <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <SkeletonDivElement height={'20px'} width={'90px'} borderRadius={'14px'} />
                        </div>

                        <div>
                            <SkeletonDivElement height={'20px'} width={'90px'} borderRadius={'14px'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkeletonForServices;